.i3{border:1px solid var(--gray-200);}